<!--资格码报单-->
<template>
  <div>
    <app-breadcrumb />
    <div v-loading="doLoading" class="page-container Qualification">
      <el-table v-if="isAgent" :data="list" border size="mini" fit highlight-current-row max-height="270px"
        style="width: 100%;margin-bottom: 20px">
        <!--经销商编号-->
        <el-table-column :label="$t('miMember.memberNo')" prop="havedNo" align="center" />
        <!--资格码-->
        <el-table-column :label="$t('Qualification_code')" prop="qualificationCode" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.qOrderNo" @click="copyData(scope.row.qualificationCode)" style="color: #b3640d">{{
              scope.row.qualificationCode }}</span>
            <span v-else style="color: #999999">{{ scope.row.qualificationCode }}</span>
          </template>
        </el-table-column>
        <!--订单编号-->
        <el-table-column :label="$t('poOrder.orderNo')" prop="qOrderNo" align="center">
          <template slot-scope="scope">
            {{ scope.row.qOrderNo ? scope.row.qOrderNo : $t('Unused') }}
          </template>
        </el-table-column>
      </el-table>
      <el-form label-width="auto" size="mini">
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <el-form-item size="mini" :label="$t('miMember.memberNo') + ':'" class="hong-xing">
              <!--:readonly="memberNoDisabled"-->
              <!-- <el-input :class="{ 'disabled_remove_css': memberNoDisabled }" v-model.trim="formData.memberNo" clearable
                :placeholder="$t('')" @blur="getAgentNo()" /> -->
              {{ formData.memberNo }}
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <p :class="{ 'account_name_css': account_name_show }"
              style="color:#538E0D; font-weight:bold; line-height: 4px;">
              {{
                memberNoData.accountName }}
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--资格码-->
            <el-form-item size="mini" :label="$t('Qualification_code') + ':'" class="hong-xing">
              <el-input v-model.trim="formData.qualificationCode" clearable :placeholder="$t('')"
                @blur="checkQualificationCode()" />
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <p :class="{ 'account_name_css': qualificationAble }" style="font-weight:bold; line-height: 4px;">
            </p>
          </el-col>
        </el-row>
        <div v-if="!isAgent">
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        收货人姓名-->
              <el-form-item size="mini" :label="$t('PoOrder.recName')" class="hong-xing">
                <el-input v-model.trim="formData.name" clearable :placeholder="$t('')" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        联系电话-->
              <el-form-item size="mini" :label="$t('sysCompany.phone')" class="hong-xing">
                <el-input v-model.trim="formData.recPhone" clearable :placeholder="$t('')" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        收货地址-->
              <el-form-item :label="$t('ssCustomer.saddress')">
                <el-radio-group class="radio-group" v-model="formData.recType">
                  <el-radio :label="1">
                    {{ this.$t('pick.up.from.franchise') }}:{{ memberNoData.agentNo }} - {{ memberNoData.agentName }}
                  </el-radio>
                  <div style="margin: 10px 0" />
                  <el-radio :label="2">
                    {{ this.$t('pick.up.from.branch.office') }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--         支付密码 -->
            <el-form-item size="mini" :label="$t('please.input.your.pay.password') + ':'" class="hong-xing">
              <el-input v-model.trim="formData.payPassword" show-password clearable placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <el-form-item size="mini" :label="$t('pmEfuboCard.amount') + ':'">
              400$
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <el-form-item size="mini" :label="$t('pdWarehouseStock.productNo') + ':'">
              <table>
                <tr v-for="item in formData.goodsList" :key="item.goodsCode">
                  <td>{{ item.goodsName }}</td>
                  <td>({{ item.goodsCode }})</td>
                  <td>x{{ item.buyQty }}</td>
                </tr>
              </table>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
        <!--        提交-->
        <el-button size="mini" :loading="doLoading" type="success" icon="el-icon-check" @click="formSubmit">
          {{ $t('title.submit') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {
  miMemberInfo,
  procQualificationCanUse2,
  procQualificationListByAgent2,
  procQualificationSaveOrder
} from "@/api/member";
import { mapGetters } from "vuex";

export default {
  name: 'Qualification',
  directives: {},
  components: {},
  data() {
    return {
      formData: {
        payPassword: '',
        memberNo: '',
        qualificationCode: '',
        payType: '',
        name: '',
        recPhone: '',
        recType: '',
        storeAddr: '',
        goodsList: [
          { goodsCode: 'WX037-A', goodsName: 'Diary-S', buyQty: 1 },
          { goodsCode: 'T021-66', goodsName: 'Fohow T-shirt', buyQty: 1 },
          { goodsCode: 'E018-00', goodsName: 'Pen', buyQty: 1 },
        ]
      },
      memberNoData: {
        accountName: null
      },
      list: [],
      qualificationAble: false,
      memberNoDisabled: false,
      account_name_show: false,
      doLoading: false,
      total: 0
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.getAgentNo()
    if (this.isAgent) {
      this.getList()
    }
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    getList() {
      this.doLoading = true
      procQualificationListByAgent2().then(res => {
        this.doLoading = false
        this.list = res.data
      }).catch(err => {
        console.error(err)
        this.doLoading = false
      })
    },
    checkQualificationCode() {
      this.doLoading = true
      this.qualificationAble = false
      console.log(this.formData.qualificationCode)
      if (!this.formData.qualificationCode) {
        this.doLoading = false
        this.qualificationAble = true
        return
      }
      procQualificationCanUse2({
        qualificationCode: this.formData.qualificationCode
      }).then(res => {
        this.formData.memberNo = res.data.havedNo
        this.doLoading = false
        this.qualificationAble = false
        console.log(res)
      }).catch(err => {
        console.error(err)
        this.doLoading = false
        this.qualificationAble = true
      })
    },
    async getAgentNo() {
      this.memberNoDisabled = !this.isAgent
      this.formData.memberNo = !this.isAgent ? this.userCode : this.formData.memberNo
      if (this.formData.memberNo) {
        try {
          this.doLoading = true
          let res = await miMemberInfo({ memberNo: this.formData.memberNo })
          this.memberNoData = res.data
          this.formData.name = this.memberNoData.name
          this.formData.recPhone = this.memberNoData.mobile
          this.formData.storeAddr = this.memberNoData.storeAddr
          this.doLoading = false
          this.account_name_show = false
          console.log(JSON.parse(JSON.stringify(this.memberNoData)))
        } catch (err) {
          console.log(err)
          this.doLoading = false
          this.memberNoData.accountName = ''
          this.account_name_show = true
        }
      }
    },
    formSubmit() {
      if (!this.formData.qualificationCode) {
        this.$message.warning(this.$t('label.pleaseFillIn').toString() + ' ' + this.$t('Qualification_code').toString())
        return
      }
      if (!this.formData.payPassword) {
        this.$message.warning(this.$t('please.input.your.pay.password').toString())
        return
      }
      // if (this.formData.totalAmount === 'A' || this.formData.totalpointa0 === 'A' || this.formData.totalF0 === 'A') {
      //   this.$message.warning(this.$t('poOrder.pleaseChoose').toString() + ' ' + this.$t('poOrder.payWay').toString())
      //   return
      // }
      this.formData.totalAmount = 400
      this.doLoading = true
      procQualificationSaveOrder({ ...this.formData }).then(() => {
        this.doLoading = false
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        this.$router.push({ name: 'OrderQuery' })
      }).catch(err => {
        console.error(err)
        this.doLoading = false
      })
    },
    copyData(val) {
      // navigator.clipboard.writeText(val).then(()=>{
      //   this.$message.success('copy success')
      // })
      const textArea = document.createElement('textArea')
      textArea.value = val
      textArea.style.width = 0
      textArea.style.position = 'fixed'
      textArea.style.left = '-999px'
      textArea.style.top = '10px'
      textArea.setAttribute('readonly', 'readonly')
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      this.$message.success('copy success')
      document.body.removeChild(textArea)
    },
  }
}

</script>

<style lang="scss" scoped>
.account_name_css:after {
  content: 'X';
  color: #ff4949;
}

.hong-xing {
  ::v-deep.el-form-item__label:before {
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
</style>
